import React from 'react';

function HeroContent({ heading, subheading, className }) {
  return (
    <div className={`hero-content ${className || ''}`}>
      <h1 className="hero-heading">{heading}</h1>
      <p className="hero-subheading">{subheading}</p>
    </div>
  );
}

export default HeroContent; 